import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVDate } from "../../shared/JVDate";
import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import {
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    startOfQuarter,
    endOfQuarter
} from "date-fns";
import { Fetch } from "../../shared/Fetch";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { IDropdown } from "../../models/BaseModel";

export interface IFilter {
    name?: string;
    fromDate?: Date;
    toDate?: Date;
    range?: string;

}

interface Iprops {
    filter: IFilter;
    loading: boolean;
    header: any;
    setFilter: (filter: IFilter) => void;
}

export const Filter = (props: Iprops) => {
    const [users, setUsers] = useState<IDropdown[]>([]);

    const { control, handleSubmit, reset, watch, setValue, trigger } = useForm<IFilter>({
        defaultValues: props.filter
    });

    const fromDate = watch("fromDate");
    const toDate = watch("toDate");
    const range = watch("range");

    //  Load Users
    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        const res = await Fetch("user/dropdown", "GET", null, null, null);
        if (res) {
            const data = await res.json();
            setUsers(data);
        }
    };

    // 🔹 Range Logic (Quick Select)
    useEffect(() => {
        if (range) {
            let start: Date | undefined;
            let end: Date | undefined;
            const now = new Date();

            switch (range) {
                case "this-week":
                    start = startOfWeek(now);
                    end = endOfWeek(now);
                    break;
                case "this-month":
                    start = startOfMonth(now);
                    end = endOfMonth(now);
                    break;
                case "quarterly":
                    start = startOfQuarter(now);
                    end = endOfQuarter(now);
                    break;
            }

            if (start && end) {
                reset({
                    ...watch(),
                    fromDate: start,
                    toDate: end,
                    range: range
                });
            }
        }
    }, [range]);

    // 🔹 Date Validation
    useEffect(() => {
        if (fromDate || toDate) {
            trigger(["fromDate", "toDate"]);
        }
    }, [fromDate, toDate]);

    // 🔹 Submit
    const onSubmit = (data: IFilter) => {
        props.setFilter(data);
    };

    // 🔹 Clear
    const clear = () => {
        const today = new Date();

        const resetData: IFilter = {
            fromDate: today,
            toDate: today,
            range: undefined,

        };

        reset(resetData);
        props.setFilter(resetData);
    };

    return (
        <Accordion>
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid grid formgrid">

                    <div className="field col-12 md:col-3">
                        <label htmlFor="range">Quick Select</label>
                        <Dropdown
                            id="range"
                            value={range}
                            options={[
                                { label: "This Week", value: "this-week" },
                                { label: "This Month", value: "this-month" },
                                { label: "Quarterly", value: "quarterly" }
                            ]}
                            onChange={(e) =>
                                reset({ ...watch(), range: e.value })
                            }
                            placeholder="Select Range"
                            showClear
                        />
                    </div>

                    {/* From Date */}
                    <JVDate
                        column={3}
                        label="From Date"
                        control={control}
                        name="fromDate"
                        rules={{
                            required: {
                                value: !!toDate,
                                message: "From Date is required"
                            }
                        }}
                        required={!!toDate}
                        maxDate={new Date()}

                    />

                    {/* To Date */}
                    <JVDate
                        column={3}
                        label="To Date"
                        control={control}
                        name="toDate"
                        minDate={fromDate}
                        maxDate={new Date()}
                        rules={{
                            required: {
                                value: !!fromDate,
                                message: "To Date is required"
                            }
                        }}
                        required={!!fromDate}
                    />

                    {/* MultiSelect Users */}
                    {/* <JVMultiselect
                        column={3}
                        filter
                        label="Assign To"
                        options={users}
                        optionLabel="name"
                        optionValue="id"
                        value={watch("assigned_To") || []}
                        placeholder="Select Users"
                        onChange={(ids: number[]) => {
                            setValue("assigned_To", ids);
                        }}
                    /> */}

                    {/* Buttons */}
                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Search"
                            type="submit"
                            loading={props.loading}
                            className="p-button-sm p-button-rounded"
                            style={{ width: "90px", height: "32px" }}
                        />

                        <Button
                            label="Clear"
                            type="button"
                            onClick={clear}
                            className="p-button-sm p-button-rounded p-button-outlined"
                            style={{ width: "90px", height: "32px" }}
                        />
                    </div>

                </form>
            </AccordionTab>
        </Accordion>
    );
};